import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalIban } from '..'

const residenceDependentFields = ['iban']

const ExternalIbanCountryDependent = ({ i18n, type, name, required, requiredForCountries }) => {
  const [isShown, setIsShown] = useState(true)
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalIban
      name={name}
      i18nLabel={i18n}
      type={type}
      required={required}
    />
  ) : null
}

const getExternalIbanCountryDependentFields = textField => {
  return (
    <ExternalIbanCountryDependent {...textField} key={textField.name} />
  )
}

export { ExternalIbanCountryDependent, getExternalIbanCountryDependentFields }
